export { default as Apollo, isProductionEnvironment } from './api'
export type { Env } from './api'
